import React from 'react';
import Reveal from '../Reveal/Reveal';
import '../../styles/stories.css';

const PUB = process.env.PUBLIC_URL;

/* Photos live in public/stories/ as 1.jpg … 6.jpg.
   Edit the title and caption text below to describe each photo. */
const STORIES = [
  {
    img: `${PUB}/stories/4.jpg`,
    title: 'Every Drop Counts',
    caption:
      'Drip irrigation carries water straight to the roots — mindful of every precious drop we draw from the earth.',
  },
  {
    img: `${PUB}/stories/5.jpg`,
    title: 'Our Azolla Bed',
    caption:
      'Azolla, a fast-growing water fern that naturally fixes nitrogen — a protein-rich, organic feed for our poultry, ducks and cattle, and green manure for the soil.',
  },
  {
    img: `${PUB}/stories/6.jpg`,
    title: 'Ripe on the Tree',
    caption:
      'Mangoes ripening naturally on the tree, sweetened by sun and time — picked only when perfectly ready.',
  },
];

const FALLBACK =
  'https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=700&q=70';

export default function PhotoStories() {
  return (
    <section id="stories" className="section stories">
      <div className="container">
        <Reveal className="section-head">
          <h2 className="section-title">Moments from our farm</h2>
          <p className="section-subtitle">
            A glimpse into everyday life at Mahizh — the people, the land and
            the little moments behind every harvest.
          </p>
        </Reveal>

        <div className="stories__grid">
          {STORIES.map((s, i) => (
            <Reveal
              key={s.title}
              delay={Math.min((i % 3) + 1, 5)}
              as="figure"
              className="story-card"
            >
              <div className="story-card__media">
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = FALLBACK;
                  }}
                />
              </div>
              <figcaption className="story-card__body">
                <h3 className="story-card__title">{s.title}</h3>
                <p className="story-card__caption">{s.caption}</p>
              </figcaption>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
